module.exports = __webpack_public_path__ + "img/shipping-orange.9fef6d3c.svg";